<template>
  <form class="base-page" v-on:submit.prevent="save">
    <div class="base-page__toolbar">
      <div class="base-page__toolbar-card">
        <div class="base-page__primary-actions">
          <div class="btn-group base-page__button-group">
            <button
              type="submit"
              v-if="!isHideSave"
              class="btn btn-sm btn-outline-success"
            >
              {{ $filters.localize("button.save") }}
            </button>
            <button
              type="button"
              v-on:click="$router.go(-1)"
              class="btn btn-sm btn-outline-primary"
            >
              {{ $filters.localize("button.close") }}
            </button>
            <button
              type="button"
              v-if="action === 'update' && !isHideRemove"
              v-on:click="remove"
              class="btn btn-sm btn-outline-danger"
            >
              {{ $filters.localize("button.remove") }}
            </button>
            <slot
              name="panel-group"
              class="text-right"
              v-bind:entity="entity"
              v-bind:save="save"
            ></slot>
          </div>
        </div>
        <div class="base-page__secondary-actions">
          <div class="btn-group base-page__button-group">
            <slot
              name="panel-button"
              v-bind:entity="entity"
              v-bind:save="save"
            ></slot>
          </div>
        </div>
        <div
          v-if="$slots['toolbar-end']"
          class="base-page__toolbar-trailing"
        >
          <slot
            name="toolbar-end"
            v-bind:entity="entity"
          ></slot>
        </div>
      </div>
    </div>
    <div class="base-page__content">
      <aside class="base-page__side-panel">
        <div class="base-page__panel-inner">
          <slot name="panel-left" :entity="entity" :action="action"></slot>
        </div>
      </aside>
      <main class="base-page__main-panel">
        <section class="base-page__header-card">
          <div class="base-page__panel-inner">
            <slot name="header" :entity="entity" :action="action"></slot>
          </div>
        </section>
        <section class="base-page__body-card">
          <slot
            name="body"
            :entity="entity"
            :onLoadData="onLoadData"
            :action="action"
            :save="save"
          ></slot>
        </section>
      </main>
    </div>
  </form>
</template>

<script>
export default {
  name: "BasePage",
  props: {
    schemaName: String,
    isHideRemove: Boolean,
    isHideSave: Boolean,
    isLoading: Boolean,
    loadingText: {
      type: String,
      default: "Завантаження...",
    },
    entity: {
      type: Object,
      default: () => ({ id: null }),
    },
  },
  emits: ["update:entity", "saved"],
  data: () => ({
    action: "add",
    isPageLoading: false,
    isSaving: false,
  }),
  mounted() {
    this.onLoadData();
  },
  computed: {
    request: {
      get() {
        var keys = Object.keys(this.localEntity)
          .filter((x) => x.includes("Id"))
          .map((x) => x.replace("Id", ""));
        var obj = this.localEntity;
        keys.forEach((x) => (obj[x] = null));
        return JSON.parse(JSON.stringify(obj));
      },
    },
    localEntity: {
      get() {
        const rawRoute = {
          ...this.$route.query,
          ...this.$route.params,
        };

        const routeData = Object.fromEntries(
          Object.entries(rawRoute).filter(([_, v]) => v !== "" && v != null)
        );

        return {
          ...routeData,
          ...this.entity,
        };
      },
      set(val) {
        this.$emit("update:entity", { ...val });
      },
    },
    basePage: {
      get() {
        return this.baseSection + "Page";
      },
    },
    baseSection: {
      get() {
        return (
          this.schemaName.charAt(0).toUpperCase() + this.schemaName.slice(1)
        );
      },
    },
    isBusy() {
      return this.isLoading || this.isPageLoading || this.isSaving;
    },
  },
  methods: {
    async save(event, resolve, reject, options) {
      this.isSaving = true;
      try {
        var response = await this.$store.dispatch(this.action, {
          table: this.schemaName,
          body: this.request,
        });
        if (response.data?.status === false) {
          this.$toast.warning(response.data.message || "Не вдалося зберегти дані");
          this.onLoadData();
          reject?.(response);
          return response;
        }
        this.localEntity = response.data.data;
        if (!options?.silent) {
          this.$toast.success("Успішно збережено");
        }
        this.action = "update";
        this.$emit("saved", response.data.data);
        resolve?.(response);
        return response;
      } catch (error) {
        this.$toast.error("Системна помилка. Не вдалось оновити дані");
        reject?.(error);
        throw error;
      } finally {
        this.isSaving = false;
      }
    },

    remove() {
      this.$store
        .dispatch("remove", { table: this.schemaName, body: this.request })
        .then(() => {
          this.$toast.success("Успішно видалено");
          this.$router.go(-1);
        })
        .error((error) => {
          this.$toast.error(error.response.data.Message);
        });
    },

    onLoadData() {
      this.isPageLoading = true;
      this.$store
        .dispatch("index", { table: this.schemaName, body: this.request })
        .then((response) => {
          var result = response.data;
          this.localEntity = result.data;
          this.$route.params.id = this.localEntity.id;
          this.action = result.status ? "update" : "add";
          this.isPageLoading = false;
        })
        .catch(() => {
          this.isPageLoading = false;
          this.$toast.error("Системна помилка. Не вдалось оновити дані");
        });
    },
  },
};
</script>

